export enum NodeMenuId {
  FontSize = 'FontSize',
  ThemeColor = 'ThemeColor',
  TextAlign = 'TextAlign',
  FontStrikethrough = 'FontStrikethrough',
  HyperLink = 'HyperLink',
  DeleteNode = 'DeleteNode',
  NodeDescription = 'NodeDescription',
  Grouping = 'Grouping',
  Reaction = 'Reaction',
}

const NodeMenuIdList: Readonly<NodeMenuId[]> = [
  NodeMenuId.FontSize,
  NodeMenuId.ThemeColor,
  NodeMenuId.TextAlign,
  NodeMenuId.FontStrikethrough,
  NodeMenuId.HyperLink,
  NodeMenuId.NodeDescription,
  NodeMenuId.Grouping,
  NodeMenuId.Reaction,
  NodeMenuId.DeleteNode,
] as const;

export namespace NodeMenuId {
  export function values(): Readonly<NodeMenuId[]> {
    return NodeMenuIdList;
  }
}
